const VIPSonkoProfileIndex = () => import('./index.vue')
const ExpertiseIndex = () => import('./expertise.vue')

import { VIPSonkoGuard, CheckAuth } from '@/common/guard'
export default [
    {
        path: '/vip_sonko/profile',
        beforeEnter: VIPSonkoGuard,
        component: VIPSonkoProfileIndex,
        name: 'VIPSonkoProfileIndex'
    },
    {
        path: '/vip_sonko/expertise/update/:status',
        beforeEnter: CheckAuth,
        component: ExpertiseIndex,
        name: 'VIPSonkoExpertiseIndex'
    },
]